//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import TaskActionButton from '../Task/TaskActionButton.vue'

export default {
  components: {
    TaskActionButton
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    displayCloseRequestMgt: function () {
      const closureInfo = this.request.supTaskData && this.request.supTaskData.closureInfo || null
      return !!(this.request.id && closureInfo && !closureInfo.closed && this.$d_hasRole('admin', 'dispatcher'))
    },
    disableCloseRequestMgt: function () {
      return this.displayCloseRequestMgt && !this.request.supTaskData.closureInfo.closureAvailable
    },
    disableCloseRequestMgtMessage: function () {
      if (this.disableCloseRequestMgt) {
        return this.getRequestMgtClosureUnavailableMessage(this.request.supTaskData.closureInfo)
      }
      return null
    }
  },
  methods: {
    onCloseRequestMgt: function (event, navigateFn, loadingActivity) {
      const supTaskVersions = this.request.supTaskData.supTask
      const supTask = supTaskVersions && supTaskVersions.length && supTaskVersions[supTaskVersions.length - 1] || {}
      const actionName = 'Закрытие задачи в ПТК АПТС'

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            loadingActivity && loadingActivity.startLoading(actionName)
            this.closeRequestMgt()
              .finally(() => {
                loadingActivity && loadingActivity.stopLoading()
              })
          }
        },
        header: actionName,
        // warning: ['Закрыть задачу в ПТК АПТС?'],
        propsConfig: {
          number: { type: 'text', label: 'Номер задачи ПТК АПТС', value: supTask.number, readonly: true },
          address: { type: 'text', label: 'Адрес', value: supTask.address, readonly: true }
        },
        buttons: [
          { key: 'yes', name: 'Подтвердить' },
          { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
        ]
      })
    },
    getRequestMgtClosureUnavailableMessage: function (closureInfo) {
      let message
      if (closureInfo.closed) {
        message = 'Задача ПТК АПТС уже закрыта'
      } else if (!closureInfo.matchBPState) {
        message = 'Статус заявки «' + this.request.bpStateName + '» не удовлетворяет условиям отмены задачи ПТК АПТС'
      } else if (!closureInfo.matchSupStatus) {
        message = 'Текущий статус задачи: ' + closureInfo.statusName
        if (closureInfo.cancelTimeoutExceeded) {
          message = message + '. Истек разрешенный срок изменений (30 дней)'
        } else {
          message = message + '. Статус не удовлетворяет условиям закрытия'
        }
      } else {
        const messages = []
        if (!closureInfo.requiredWorksDone) {
          messages.push('Не выполнены обязательные работы')
        }
        if (!closureInfo.hasRequiredPhotos) {
          messages.push('Отсутствуют фотографии до/после выполнения работ')
        }
        if (messages.length) {
          message = messages.join('. \n')
        }
      }
      if (message == null) {
        message = 'Задача ПТК АПТС не может быть закрыта'
      }
      return message
    },
    closeRequestMgt: function () {
      const params = new URLSearchParams()
      params.append('id', this.request.id)

      return axiosGet({
        url: '/service/delta/request/closeSupTask?' + params.toString(),
        onSuccess: (response) => {
          const supTaskData = response.data.result
          this.request.supTaskData = supTaskData

          this.$q.notify({
            type: 'positive',
            message: response.data && response.data.message || 'Задача ПТК АПТС закрыта',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          let message
          let caption
          if (response.code === 'timeout') {
            message = 'Истек таймаут запроса закрытия задачи ПТК АПТС'
            caption = 'Повторите операцию, при повторной ошибке обратитесь к администратору.'
          } else {
            message = 'Ошибка закрытия задачи ПТК АПТС'
            const result = response.result
            if (result && result.closureInfo && result.closureInfo.closureAvailable === false) {
              this.request.supTaskData = result

              caption = this.getRequestMgtClosureUnavailableMessage(result)
            } else {
              caption = response && response.message || null
            }
          }

          this.$q.notify({
            type: 'negative',
            message: message,
            caption: caption,
            timeout: 8000,
            progress: true
          })
        }
      })
    }
  }
}

